import type { Song } from "../types";

interface TrackListProps {
  songs: Song[];
  selected?: string;
  cover?: string;
  onSelect(song: string): void;
}

export function TrackList({ songs, selected, cover, onSelect }: TrackListProps) {
  return (
    <fieldset className="track-list">
      <legend className="sr-only">选择这张专辑中的一首歌</legend>
      {songs.map((song, index) => {
        const active = selected === song.song;
        return (
          <label className={`track-row ${active ? "is-selected" : ""}`} key={song.song}>
            <input
              type="radio"
              name={`album-${song.album}`}
              value={song.song}
              checked={active}
              onChange={() => onSelect(song.song)}
            />
            {cover ? <img className="track-thumb" src={cover} alt="" style={{ objectPosition: `${20 + (index % 3) * 30}% ${18 + (index % 4) * 22}%` }} /> : null}
            <span className="track-index">{String(index + 1).padStart(2, "0")}</span>
            <span className="track-name">{song.song}</span>
            <span className="track-mark" aria-hidden="true">{active ? "●" : "○"}</span>
          </label>
        );
      })}
    </fieldset>
  );
}
